function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "scale(1.6667)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.25 11.25c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.25 14.25v6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 17.25,20.25L15,18 "
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.25 20.25 2.25-2.25"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.75 6.75h10.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.75 11.25h6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.75 15.75h3.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 7.5,20.25H2.25 c-0.828,0-1.5-0.672-1.5-1.5V2.25c0-0.828,0.672-1.5,1.5-1.5h10.629c0.398,0,0.779,0.158,1.06,0.439l2.872,2.872 c0.281,0.281,0.439,0.662,0.439,1.06V7.5"
}));

function SvgDropFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgDropFile);
export default __webpack_public_path__ + "static/media/drop_file.a9226031.svg";
export { ForwardRef as ReactComponent };